/* global axios */
import { ref } from 'vue';

// Exclusão mútua de MÉTODO DE LIGAÇÃO por caixa (Wavoip / AstraCall / API oficial:
// só um por caixa). Busca no backend quais estão ativos na caixa e ajuda a UI a
// desabilitar o toggle conflitante. A regra é garantida no backend
// (config/initializers/kanban_call_method_exclusion.rb); isto é só a camada de UX.
const LABELS = { wavoip: 'Legado', astracall: 'AstraCall', official: 'API oficial' };

export function useCallMethodExclusion() {
  const methods = ref({
    wavoip: false,
    astracall: false,
    official: false,
    is_official: false,
    is_hybrid: false,
  });
  const loaded = ref(false);

  const fetchMethods = async (accountId, inboxId) => {
    loaded.value = false;
    if (!accountId || !inboxId) {
      loaded.value = true;
      return;
    }
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId}/kanban/connections/call_methods`,
        { params: { inbox_id: inboxId } }
      );
      methods.value = { ...methods.value, ...(data.data || {}) };
    } catch (e) {
      // fail-open: sem info, não bloqueia a UI (o backend ainda garante a regra)
    } finally {
      loaded.value = true;
    }
  };

  // Nomes (labels) dos OUTROS métodos já ativos que conflitam com `method`.
  const conflictLabelsFor = method =>
    ['wavoip', 'astracall', 'official']
      .filter(m => m !== method && methods.value[m])
      .map(m => LABELS[m]);

  return { methods, loaded, fetchMethods, conflictLabelsFor };
}
